module.exports = __webpack_public_path__ + "static/media/reject_payment.5b6b32f8.png";